module.exports = __webpack_public_path__ + "static/bibliothek-a047ea09ef4d4b946bbeda7f54533bdb.PNG";